const JSONSet = require('../../datastructures/JSONSet');
class CountriesModel extends JSONSet {
  constructor() {
    super();
  }
  deserialise(data) {
    data.forEach(country => this.add(country.iso));
    return this;
  }
}

module.exports = CountriesModel;
